import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Campaign } from '~/api/models/campaign';
import { Divider } from '@rio-cloud/rio-uikit';

interface CampaignTargetVehiclesSectionProps {
  campaign: Campaign;
  onEditClick: () => void;
}

const CampaignTargetVehiclesSection: React.FC<CampaignTargetVehiclesSectionProps> = ({
  campaign,
  onEditClick
}) => {
  const vehicleGroups = campaign?.vehicleGroup ? [campaign.vehicleGroup] : [];

  return (
    <div>
      <div className='display-flex align-items-center justify-content-between'>
          <span className='title margin-right-10'><FormattedMessage id={'intl-msg:campaign:targetVehicles'}/></span>
          <button
          className='btn btn-link margin-left-10 padding-0'
          onClick={onEditClick}
        >
          <span className='rioglyph rioglyph-pencil'></span>
        </button>
      </div>
      <div className='display-flex align-items-center'>
        <Divider className='width-100pct padding-top-0'/>
      </div>

        <div className='margin-top-15'>
        {vehicleGroups.length > 0 ? (
          <div className='display-flex flex-wrap gap-10'>
            {vehicleGroups.map((group, index) => (
              <div key={index} className='badge badge-info padding-5'>
                {group}
              </div>
            ))}
          </div>
        ) : (
          <div className='text-color-gray'>
              <FormattedMessage id='intl-msg:campaign:NoGroupSelected'/>
          </div>
        )}
      </div>
    </div>
  );
};

export default CampaignTargetVehiclesSection;
